import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "../../../public/ESGCaffe Light Mode Logo.png";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail("");
    }
  };

  return (
    <footer className="bg-gradient-to-b from-[#fffbf5] to-[#f5efe4] text-gray-900">
      {/* Newsletter strip */}
      <div className="border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-lg font-semibold text-gray-900">Stay ahead of ESG regulations</h3>
              <p className="text-sm text-gray-600 mt-1">Get monthly insights on compliance, frameworks, and sustainability trends.</p>
            </div>
            {subscribed ? (
              <p className="text-emerald-600 text-sm font-medium">Thanks for subscribing!</p>
            ) : (
              <form onSubmit={handleSubscribe} className="flex gap-2 w-full md:w-auto">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  className="px-4 py-2.5 bg-white border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500/40 focus:border-blue-500/40 w-full md:w-72 transition-all dark:bg-white dark:text-gray-900 dark:border-gray-300 dark:placeholder:text-gray-400"
                />
                <button
                  type="submit"
                  className="px-5 py-2.5 bg-blue-500 hover:bg-blue-600 text-white text-sm font-medium rounded-md transition-all flex items-center gap-2 whitespace-nowrap shadow-sm"
                >
                  Subscribe
                  <ArrowRight className="w-4 h-4" />
                </button>
              </form>
            )}
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
          {/* Brand */}
          <div className="col-span-2">
            <Link to="/esg-360" className="flex items-center gap-2 mb-5">
              <img src="/logo.png" alt="DataCaffe" className="h-10 w-10 object-contain" />
              <div className="flex flex-col leading-tight">
                <span className="text-2xl font-bold tracking-tight">
                  <span style={{ color: '#f97316' }}>ESG</span><span className="text-blue-400">Caffe</span>
                </span>
                <span className="text-[8px] font-medium tracking-[0.28em] text-gray-500 uppercase">GREEN INTELLIGENCE</span>
              </div>
            </Link>
            <p className="text-gray-600 text-sm leading-relaxed max-w-xs">
              AI-powered ESG compliance platform. Turn sustainability reporting from a burden into a competitive advantage.
            </p>
            <div className="flex gap-3 mt-5">
              {/* LinkedIn */}
              <a
                href="https://in.linkedin.com/company/datacaffeai"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-colors border border-gray-200"
                aria-label="LinkedIn"
              >
                <svg className="w-4 h-4 fill-current text-gray-600" viewBox="0 0 448 512">
                  <path d="M100.28 448H7.4V149.5h92.88zm-46.44-339a53.24 53.24 0 1 1 53.15-53.24A53.25 53.25 0 0 1 53.84 109zm394.12 339h-92.89V302.4c0-34.7-.7-79.3-48.3-79.3-48.3 0-55.8 37.7-55.8 76.6V448H158.2V149.5h89.21v40.7h1.3a97.75 97.75 0 0 1 87.9-48.3c94 0 111.3 61.9 111.3 142.3V448z" />
                </svg>
              </a>
              {/* Instagram */}
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-colors border border-gray-200"
                aria-label="Instagram"
              >
                <svg className="w-4 h-4 fill-current text-gray-600" viewBox="0 0 448 512">
                  <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9 114.9-51.3 114.9-114.9S287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/>
                </svg>
              </a>
              {/* Facebook */}
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-colors border border-gray-200"
                aria-label="Facebook"
              >
                <svg className="w-4 h-4 fill-current text-gray-600" viewBox="0 0 320 512">
                  <path d="M279.14 288l14.22-92.66h-88.91V135.3c0-25.35 12.42-50.06 52.24-50.06H293V6.26S259.5 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Platform */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4 uppercase tracking-wider">Platform</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/features" className="text-gray-600 hover:text-gray-900 transition-colors">Features</Link></li>
              <li><Link to="/ai-platform" className="text-gray-600 hover:text-gray-900 transition-colors">AI Platform</Link></li>
              <li><Link to="/pricing" className="text-gray-600 hover:text-gray-900 transition-colors">Pricing</Link></li>
              <li><Link to="/how-it-works" className="text-gray-600 hover:text-gray-900 transition-colors">How It Works</Link></li>
              <li><Link to="/integrations" className="text-gray-600 hover:text-gray-900 transition-colors">Integrations</Link></li>
              <li><Link to="/comparison" className="text-gray-600 hover:text-gray-900 transition-colors">Comparison</Link></li>
            </ul>
          </div>

          {/* Frameworks */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4 uppercase tracking-wider">Frameworks</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/frameworks/gri" className="text-gray-600 hover:text-gray-900 transition-colors">GRI Standards</Link></li>
              <li><Link to="/frameworks/sasb" className="text-gray-600 hover:text-gray-900 transition-colors">SASB</Link></li>
              <li><Link to="/frameworks/tcfd" className="text-gray-600 hover:text-gray-900 transition-colors">TCFD</Link></li>
              <li><Link to="/frameworks/csrd-esrs" className="text-gray-600 hover:text-gray-900 transition-colors">CSRD / ESRS</Link></li>
              <li><Link to="/frameworks/sebi-brsr" className="text-gray-600 hover:text-gray-900 transition-colors">SEBI BRSR</Link></li>
              <li><Link to="/frameworks/cdp" className="text-gray-600 hover:text-gray-900 transition-colors">CDP</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4 uppercase tracking-wider">Resources</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/blog" className="text-gray-600 hover:text-gray-900 transition-colors">Blog</Link></li>
              <li><Link to="/case-studies" className="text-gray-600 hover:text-gray-900 transition-colors">Case Studies</Link></li>
              <li><Link to="/docs" className="text-gray-600 hover:text-gray-900 transition-colors">Documentation</Link></li>
              <li><Link to="/api" className="text-gray-600 hover:text-gray-900 transition-colors">API Reference</Link></li>
              <li><Link to="/faq" className="text-gray-600 hover:text-gray-900 transition-colors">FAQ</Link></li>
              <li><Link to="/security" className="text-gray-600 hover:text-gray-900 transition-colors">Security</Link></li>
              <li><Link to="/partnerships" className="text-gray-600 hover:text-gray-900 transition-colors">Partnerships</Link></li>
              <li><Link to="/announcements" className="text-gray-600 hover:text-gray-900 transition-colors">Announcements</Link></li>
            </ul>
          </div>

          {/* Pricing */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4 uppercase tracking-wider">Pricing</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/pricing" className="text-gray-600 hover:text-gray-900 transition-colors">Plans & Pricing</Link></li>
              <li><Link to="/comparison" className="text-gray-600 hover:text-gray-900 transition-colors">Compare Plans</Link></li>
              <li><Link to="/contact" className="text-gray-600 hover:text-gray-900 transition-colors">Contact Sales</Link></li>
              <li>
                <a href="mailto:support@esgcaffe.ai" className="text-gray-600 hover:text-gray-900 transition-colors">
                  support@esgcaffe.ai
                </a>
              </li>
              <li className="text-gray-600">Bengaluru, India</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500">
            &copy; {new Date().getFullYear()} DataCaffe. All rights reserved.
          </p>
          <div className="flex gap-6 text-xs text-gray-500">
            <a href="#" className="hover:text-gray-800 transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-gray-800 transition-colors">Terms of Service</a>
            <a href="#" className="hover:text-gray-800 transition-colors">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
